// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ihSU","question":"styles_question__136WQ","description":"styles_description__21y24"};